import { z } from 'zod';
import type {
  UpsertUserNeedRequestDto,
  ResourcingRequest,
} from './resourcing.types';

export interface CallUpdateRequest {
  note?: string;
  outcomeId?: number;
  resourceTitle?: string;
  resourceInteraction?: ResourcingRequest;
  needResourceInteraction?: ResourcingRequest;
  userNeedRequest?: Partial<UpsertUserNeedRequestDto>;
  callAuditorId?: string;
  isHospitalizationFollowUp?: boolean;
}

export interface AddGuideToCallRequest {
  guideId: string;
  memberId?: string;
  title?: string;
  isColdTransfer?: boolean;
}

export const AddResourceToCallRequestSchema = z.object({
  title: z.string().nonempty('Resource title is required'),
  phoneNumber: z.string().nonempty('Phone number is required'),
});

export type AddResourceToCallRequest = z.infer<
  typeof AddResourceToCallRequestSchema
>;
